module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//15.jpg?8c4f4c16bdfa4ff4393b35d16cb0de3d";